// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"cf1e67d4","129":"d139f134","144":"3cc5ebef","337":"e20a9694","547":"792319e6","585":"edf10cfb","588":"b9e3c9bf","696":"4b3e4d48","913":"23c9cb08","921":"e107630c"}[chunkId] + ".chunk.js";
};